import { useMemo, useState } from 'react';

import MultiSelectInput from '../../inputs/MultiSelectInput';

export default function MultiSelectRange({
  id,
  name,
  attrs,
  setVariablesState,
}) {
  const { min, max } = attrs;

  const options = useMemo(() => {
    let options = [];
    for (let i = Number(min); i <= Number(max); i++) {
      options.push({
        value: i,
        label: i,
      });
    }
    return options;
  }, [min, max]);

  const [value, setValue] = useState(() => {
    if (options.length === 1) {
      if (typeof setVariablesState === 'function') {
        setVariablesState({ values: options });
      }
      return options;
    }
    return null;
  });

  function handleSelectAll() {
    setValue(options);
    if (typeof setVariablesState === 'function') {
      setVariablesState({ values: options });
    }
  }

  function handleChange(value) {
    if (!value) {
      if (typeof setVariablesState === 'function') {
        setValue(value);
        setVariablesState({ values: value });
        return;
      }
    }
    setValue(value);
  }

  function handleBlur() {
    if (typeof setVariablesState === 'function') {
      setVariablesState({ values: value });
    }
  }

  return (
    <div class="flex flex-col w-full border-l-2 border-gray-400 px-2 mb-2">
      <div
        className={`mb-1 ${
          options.length > 1 ? 'flex flex-row justify-between' : ''
        }`}
      >
        {name}
        {options.length > 1 && (
          <button
            type="button"
            className="text-sm text-blue hover:text-primary"
            onClick={handleSelectAll}
          >
            Select All
          </button>
        )}
      </div>
      <MultiSelectInput
        options={options}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
      />
    </div>
  );
}
